import {
  Breadcrumb,
  CardContainer,
  CompPagination,
  Container,
  ModalChangePassword,
  ModalChangeRole,
} from "components";
import moment from "moment";
import useColorMode from "hooks/useColorMode";
import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  FaComment,
  FaFacebook,
  FaGlobe,
  FaPhone,
  FaSync,
  FaTelegram,
  FaTrash,
  FaTwitter,
  FaUserEdit,
  FaWindowClose,
} from "react-icons/fa";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { slicingWord } from "utils/slicingWord";
import { BiSortDown, BiSortUp } from "react-icons/bi";
import { RiAttachment2 } from "react-icons/ri";
import { AiOutlineMail } from "react-icons/ai";
import { IoPeople } from "react-icons/io5";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  API_URL_agent,
  API_URL_report,
  API_URL_ticket,
  API_URL_updateBatchTicket,
} from "constants/api";
import { agentReducers } from "redux/agentSlice";
import { deleteData, getData } from "actions";
import axios from "axios";
import useDebounce from "hooks/useDebounce";
import { toast } from "react-toastify";
import { SyncLoader } from "react-spinners";
import { reportReducers } from "redux/reportSlice";
import { AuthContext } from "context/AuthContext";

// field for use sort up/down
const TABLE_HEAD = [
  { title: "", field: "" },
  { title: "Subjek", field: "" },
  { title: "ID Ticket", field: "ticket_number" },
  { title: "Priority", field: "priority" },
  { title: "From", field: "client_name" },
  { title: "Assigned to", field: "assigned_to" },
  { title: "Last Activity", field: "updated_at" },
];

const ViewUserAgent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [adminAccess, setAdminAccess] = useState(false);

  const { datauser, updateCountTicket, setUpdateCountTicket } = useContext(
    AuthContext
  );
  const now = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(now.getMonth() - 1);

  const [modalPassword, setModalPassword] = useState(false);
  const [modalChangeRole, setModalChangeRole] = useState(false);

  const [startdate, setStartdate] = useState(
    moment(oneMonthAgo).format("YYYY-MM-DD")
  );
  const [enddate, setEnddate] = useState(moment(now).format("YYYY-MM-DD"));
  const [colorMode, setColorMode] = useColorMode();

  // Data Open Ticket
  const [sortColumnOpen, setSortColumnOpen] = useState("");
  const [limitOpen, setLimitOpen] = useState(5);
  const [offsetOpen, setOffsetOpen] = useState(0);
  const [sortOrderOpen, setSortOrderOpen] = useState("asc");
  const [currentPageOpen, setCurrentPageOpen] = useState(0);
  const [searchOpen, setSearchOpen] = useState("");
  const [checkAllOpen, setCheckAllOpen] = useState(false);
  const [checkedItemsOpen, setCheckedItemsOpen] = useState([]);
  const [loadingOpen, setLoadingOpen] = useState(true);
  const [errorOpen, setErrorOpen] = useState(false);
  const [refreshOpen, setRefreshOpen] = useState(false);

  // Data Close Ticket
  const [sortColumnClose, setSortColumnClose] = useState("");
  const [limitClose, setLimitClose] = useState(5);
  const [offsetClose, setOffsetClose] = useState(0);
  const [sortOrderClose, setSortOrderClose] = useState("asc");
  const [currentPageClose, setCurrentPageClose] = useState(0);
  const [searchClose, setSearchClose] = useState("");
  const [checkAllClose, setCheckAllClose] = useState(false);
  const [checkedItemsClose, setCheckedItemsClose] = useState([]);
  const [loadingClose, setLoadingClose] = useState(true);
  const [errorClose, setErrorClose] = useState(false);
  const [refreshClose, setRefreshClose] = useState(false);

  // Data Delete Ticket
  const [sortColumnDelete, setSortColumnDelete] = useState("");
  const [limitDelete, setLimitDelete] = useState(5);
  const [offsetDelete, setOffsetDelete] = useState(0);
  const [sortOrderDelete, setSortOrderDelete] = useState("asc");
  const [currentPageDelete, setCurrentPageDelete] = useState(0);
  const [searchDelete, setSearchDelete] = useState("");
  const [checkAllDelete, setCheckAllDelete] = useState(false);
  const [checkedItemsDelete, setCheckedItemsDelete] = useState([]);
  const [loadingDelete, setLoadingDelete] = useState(true);
  const [errorDelete, setErrorDelete] = useState(false);
  const [refreshDelete, setRefreshDelete] = useState(false);

  // data Ticket
  const [dataTicketOpen, setDataTicketOpen] = useState([]);
  const [dataTicketClose, setDataTicketClose] = useState([]);
  const [dataTicketDelete, setDataTicketDelete] = useState([]);

  const { getReportLoading, getReportResult, getAgentResult } = useSelector(
    (state) => ({
      getReportResult: state.report.getReportResult,
      getReportLoading: state.report.getReportLoading,
      getAgentResult: state.agent.getAgentResult,
    })
  );

  // Fetch Report
  const getReport = useCallback(
    async (params) => {
      getData(
        API_URL_report,
        params,
        { dispatch, redux: reportReducers },
        "GET_REPORT"
      );
    },
    [dispatch]
  );

  //Fetch User
  const getUser = useCallback(
    async (params) => {
      getData(
        API_URL_agent,
        params,
        { dispatch, redux: agentReducers },
        "GET_AGENT"
      );
    },
    [dispatch]
  );

  const fetchDataUser = useCallback(() => {
    //get id 1 for setting
    const params = `${location.state?.item.id}/`;
    getUser(params);
  }, [getUser, location.state?.item.id, modalChangeRole]);

  // Fetch Ticket
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
    },
    method: "GET",
  };
  const fetchData = (params, onData, onError) => {
    axios({
      ...axiosConfig,
      url: API_URL_ticket + params,
    })
      .then((response) => {
        onData(response.data);
      })
      .catch((error) => {
        console.log(error);
        onError(error);
      });
  };

  const getTicketOpen = (params) => {
    fetchData(params, setDataTicketOpen, setErrorOpen);
  };
  const getTicketClose = (params) => {
    fetchData(params, setDataTicketClose, setErrorClose);
  };
  const getTicketDelete = (params) => {
    fetchData(params, setDataTicketDelete, setErrorDelete);
  };

  const handlePageClickOpen = ({ selected }) => {
    const newOffset = selected * limitOpen;
    const params = `?client=${
      location.state?.item.id
    }&status=1&limit=${limitOpen}&offset=${newOffset}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    setOffsetOpen(newOffset);
    setCurrentPageOpen(selected);
    getTicketOpen(params);
  };

  const handlePageClickClose = ({ selected }) => {
    const newOffset = selected * limitClose;
    const params = `?client=${
      location.state?.item.id
    }&status=3&limit=${limitClose}&offset=${newOffset}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    setOffsetClose(newOffset);
    setCurrentPageClose(selected);
    getTicketClose(params);
  };

  const handlePageClickDelete = ({ selected }) => {
    const newOffset = selected * limitClose;
    const params = `?client=${
      location.state?.item.id
    }&status=3&limit=${limitClose}&offset=${newOffset}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    setOffsetClose(newOffset);
    setCurrentPageClose(selected);
    getTicketClose(params);
  };

  const delayedSearchOpen = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffsetOpen(0);
      setCurrentPageOpen(0);
      const params = `?client=${
        location.state?.item.id
      }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${value}&ordering=${
        sortOrderOpen === "desc" ? "-" : ""
      }${sortColumnOpen}`;
      getTicketOpen(params);
    }, 1000),
    [limitOpen, offsetOpen, sortOrderOpen, sortColumnOpen]
  );
  const delayedSearchClose = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffsetClose(0);
      setCurrentPageClose(0);
      const params = `?client=${
        location.state?.item.id
      }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${value}&ordering=${
        sortOrderClose === "desc" ? "-" : ""
      }${sortColumnClose}`;
      getTicketClose(params);
    }, 1000),
    [limitClose, offsetClose, sortOrderClose, sortColumnClose]
  );
  const delayedSearchDelete = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffsetDelete(0);
      setCurrentPageDelete(0);
      const params = `?client=${
        location.state?.item.id
      }&status=3&limit=${limitDelete}&offset=${offsetDelete}&search=${value}&ordering=${
        sortOrderDelete === "desc" ? "-" : ""
      }${sortColumnDelete}`;
      getTicketDelete(params);
    }, 1000),
    [limitDelete, offsetDelete, sortOrderDelete, sortColumnDelete]
  );

  const onSearchOpen = (value) => {
    setSearchOpen(value);
    delayedSearchOpen(value);
  };
  const onSearchClose = (value) => {
    setSearchClose(value);
    delayedSearchClose(value);
  };
  const onSearchDelete = (value) => {
    setSearchDelete(value);
    delayedSearchDelete(value);
  };

  const handleSortOpen = (column) => {
    //RESET PAGINATE KE 1
    setOffsetOpen(0);
    setCurrentPageOpen(0);
    if (column === sortColumnOpen) {
      setSortOrderOpen(sortOrderOpen === "asc" ? "desc" : "asc");
    } else {
      setSortColumnOpen(column);
      setSortOrderOpen("asc");
    }
  };
  const handleSortClose = (column) => {
    //RESET PAGINATE KE 1
    setOffsetClose(0);
    setCurrentPageClose(0);
    if (column === sortColumnClose) {
      setSortOrderClose(sortOrderClose === "asc" ? "desc" : "asc");
    } else {
      setSortColumnClose(column);
      setSortOrderClose("asc");
    }
  };
  const handleSortDelete = (column) => {
    //RESET PAGINATE KE 1
    setOffsetDelete(0);
    setCurrentPageDelete(0);
    if (column === sortColumnDelete) {
      setSortOrderDelete(sortOrderDelete === "asc" ? "desc" : "asc");
    } else {
      setSortColumnDelete(column);
      setSortOrderDelete("asc");
    }
  };

  //Handle Sort
  const renderSortIconOpen = (field) => {
    if (field === sortColumnOpen) {
      return sortOrderOpen === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };
  const renderSortIconClose = (field) => {
    if (field === sortColumnClose) {
      return sortOrderClose === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };
  const renderSortIconDelete = (field) => {
    if (field === sortColumnDelete) {
      return sortOrderDelete === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };

  //Handle Select Limit
  const handleSelectLimitOpen = (limitOpen) => {
    //RESET PAGINATE KE 1
    setOffsetOpen(0);
    setCurrentPageOpen(0);

    const params = `?client=${
      location.state?.item.id
    }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    getTicketOpen(params);
    setLimitOpen(limitOpen);
  };
  const handleSelectLimitClose = (limitClose) => {
    //RESET PAGINATE KE 1
    setOffsetClose(0);
    setCurrentPageClose(0);

    const params = `?client=${
      location.state?.item.id
    }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    getTicketClose(params);
    setLimitClose(limitClose);
  };
  const handleSelectLimitDelete = (limitDelete) => {
    //RESET PAGINATE KE 1
    setOffsetDelete(0);
    setCurrentPageDelete(0);

    const params = `?client=${
      location.state?.item.id
    }&status=3&limit=${limitDelete}&offset=${offsetDelete}&search=${searchDelete}&ordering=${
      sortOrderDelete === "desc" ? "-" : ""
    }${sortColumnDelete}`;
    getTicketDelete(params);
    setLimitDelete(limitDelete);
  };

  //fetch Data Tiket
  const fetchDataOpen = useCallback(() => {
    const params = `?client=${
      location.state?.item.id
    }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    getTicketOpen(params);
  }, [
    getTicketOpen,
    limitOpen,
    offsetOpen,
    sortColumnOpen,
    sortOrderOpen,
    refreshOpen,
  ]);
  const fetchDataClose = useCallback(() => {
    const params = `?client=${
      location.state?.item.id
    }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    getTicketClose(params);
  }, [
    getTicketClose,
    limitClose,
    offsetClose,
    sortColumnClose,
    sortOrderClose,
    refreshClose,
  ]);
  const fetchDataDelete = useCallback(() => {
    const params = `?client=${
      location.state?.item.id
    }&status=4&limit=${limitDelete}&offset=${offsetDelete}&search=${searchDelete}&ordering=${
      sortOrderDelete === "desc" ? "-" : ""
    }${sortColumnDelete}`;
    getTicketDelete(params);
  }, [
    getTicketDelete,
    limitDelete,
    offsetDelete,
    sortColumnDelete,
    sortOrderDelete,
    refreshDelete,
  ]);

  // Function to handle refresh
  const handleRefreshOpen = () => {
    setRefreshOpen(!refreshOpen);
    setDataTicketOpen([]);
  };
  const handleRefreshClose = () => {
    setRefreshClose(!refreshClose);
    setDataTicketClose([]);
  };
  const handleRefreshDelete = () => {
    setRefreshDelete(!refreshDelete);
    setDataTicketDelete([]);
  };

  // Function for checking all checkboxes
  const handleCheckAllChangeOpen = (e) => {
    setCheckAllOpen(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < dataTicketOpen.results?.length; i++) {
        index.push(dataTicketOpen.results[i]?.id);
      }
      const allItems = index;
      setCheckedItemsOpen(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItemsOpen([]);
    }
  };
  const handleCheckAllChangeClose = (e) => {
    setCheckAllClose(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < dataTicketClose.results?.length; i++) {
        index.push(dataTicketClose.results[i]?.id);
      }
      const allItems = index;
      setCheckedItemsClose(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItemsClose([]);
    }
  };
  const handleCheckAllChangeDelete = (e) => {
    setCheckAllDelete(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < dataTicketDelete.results?.length; i++) {
        index.push(dataTicketDelete.results[i]?.id);
      }
      const allItems = index;
      setCheckedItemsDelete(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItemsDelete([]);
    }
  };

  // Function for checking one item
  const handleCheckboxChangeOpen = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItemsOpen([...checkedItemsOpen, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItemsOpen.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItemsOpen(updatedItems);
    }
  };
  const handleCheckboxChangeClose = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItemsClose([...checkedItemsClose, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItemsClose.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItemsClose(updatedItems);
    }
  };
  const handleCheckboxChangeDelete = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItemsDelete([...checkedItemsDelete, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItemsDelete.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItemsDelete(updatedItems);
    }
  };

  //funtion to handle ticket
  const HandleToCloseForOpen = () => {
    setLoadingOpen(true);

    let dataUpdate = [];
    checkedItemsOpen.map((item, index) => {
      const data = {
        id: item,
        status: 3,
        closed: 1,
        reopened: 0,
        by_user: datauser.id,
        // closed.at:
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingOpen(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Closed Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingOpen(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };
  const HandleToDeleteForOpen = () => {
    setLoadingOpen(true);

    let dataUpdate = [];
    checkedItemsOpen.map((item, index) => {
      const data = {
        id: item,
        status: 4,
        by_user: datauser.id,
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingOpen(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Delete Succesfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingOpen(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };
  const HandleToCloseForClose = () => {
    setLoadingClose(true);

    let dataUpdate = [];
    checkedItemsClose.map((item, index) => {
      const data = {
        id: item,
        status: 3,
        closed: 1,
        reopened: 0,
        by_user: datauser.id,
        // closed.at:
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingClose(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Closed Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingClose(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };
  const HandleToDeleteForClose = () => {
    setLoadingClose(true);

    let dataUpdate = [];
    checkedItemsClose.map((item, index) => {
      const data = {
        id: item,
        status: 4,
        by_user: datauser.id,
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingClose(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Delete Succesfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingClose(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };
  const HandleToCloseForDelete = () => {
    setLoadingDelete(true);

    let dataUpdate = [];
    checkedItemsDelete.map((item, index) => {
      const data = {
        id: item,
        status: 3,
        closed: 1,
        reopened: 0,
        by_user: datauser.id,
        // closed.at:
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingDelete(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Closed Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingDelete(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };
  const HandleToDeleteForDelete = () => {
    setLoadingDelete(true);

    let dataUpdate = [];
    checkedItemsDelete.map((item, index) => {
      const data = {
        id: item,
        status: 4,
        by_user: datauser.id,
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoadingDelete(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Delete Succesfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      })
      .catch((error) => {
        setLoadingDelete(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        fetchDataDelete();
        setCheckAllOpen(false);
        setCheckAllClose(false);
        setCheckAllDelete(false);
        setCheckedItemsOpen([]);
        setCheckedItemsClose([]);
        setCheckedItemsDelete([]);
      });
  };

  // Modal Edit User
  const handleChangepassword = () => {
    setModalPassword(!modalPassword);
  };

  const handleChangeRole = () => {
    setModalChangeRole(!modalChangeRole);
  };

  const closeModalPassword = () => {
    setModalPassword(false);
  };
  const closeModalChangeRole = () => {
    setModalChangeRole(false);
  };

  useEffect(() => {
    setLoadingOpen(false);
    setLoadingClose(false);
    setLoadingDelete(false);
  }, [dataTicketOpen, dataTicketClose, dataTicketDelete]);

  const handleChangeStartdate = (e) => {
    setStartdate(e.target.value);
  };
  const handleChangeEnddate = (e) => {
    setEnddate(e.target.value);
  };

  //funtion to handle
  const handleEdit = () => {
    navigate(`/administrator/staff/agents/edit`, {
      state: {
        item: getAgentResult,
      },
    });
  };

  const HandlePreviewUser = (id) => {
    navigate(`/administrator/staff/agents/view`, {
      state: {
        item: {
          id,
        },
      },
    });
  };

  const handleDelete = () => {
    deleteData(
      API_URL_agent + location.state.item.id,
      { dispatch, redux: agentReducers },
      "DELETE_AGENT",
      () =>
        setTimeout(() => {
          window.location.href = "/administrator/staff/agents";
        }, 2000)
    );
  };

  // function Submit filter Report
  const submitFilter = (e) => {
    e.preventDefault();
    const params = `?startdate=${startdate}&enddate=${enddate}&user=${location.state?.item.id}`;
    getReport(params);
  };

  useEffect(() => {
    fetchDataOpen();
  }, [refreshOpen]);

  useEffect(() => {
    fetchDataClose();
  }, [refreshClose]);

  useEffect(() => {
    fetchDataDelete();
  }, [refreshDelete]);

  useEffect(() => {
    if (location.state === null) {
      navigate(`/administrator/staff/agents`);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state === undefined) {
      navigate("/");
    }
    const params_report = `?startdate=${startdate}&enddate=${enddate}&user=${location.state?.item.id}`;
    fetchDataOpen();
    fetchDataClose();
    fetchDataDelete();
    fetchDataUser();
    getReport(params_report);
  }, []);
  useEffect(() => {
    if (location.state === undefined) {
      navigate("/");
    }
    const params_report = `?startdate=${startdate}&enddate=${enddate}&user=${location.state?.item.id}`;
    fetchDataOpen();
    fetchDataClose();
    fetchDataDelete();
    fetchDataUser();
    getReport(params_report);
  }, [location.state?.item.id]);

  useEffect(() => {
    fetchDataOpen();
  }, [
    limitOpen,
    offsetOpen,
    sortColumnOpen,
    sortOrderOpen,
    location.state?.item.id,
  ]);
  useEffect(() => {
    fetchDataClose();
  }, [
    limitClose,
    offsetClose,
    sortColumnClose,
    sortOrderClose,
    location.state?.item.id,
  ]);
  useEffect(() => {
    fetchDataDelete();
  }, [
    limitDelete,
    offsetDelete,
    sortColumnDelete,
    sortOrderDelete,
    location.state?.item.id,
  ]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <>
      <Container>
        <Breadcrumb
          title={"View User Detail"}
          excludedPaths={["administrator", "staff"]}
        />
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-3">
            <CardContainer>
              {getAgentResult && (
                <div className="flex flex-col align-middle items-center my-4">
                  <img
                    src={getAgentResult.profile_pic ?? getAgentResult.avatar}
                    className="rounded-full h-24 w-24 border-solid border-4 border-gray-300"
                  />
                  <h4 className="text-2xl mb-4">
                    {getAgentResult.first_name} {getAgentResult.last_name}
                  </h4>
                  <ul className="w-full px-4">
                    <li className="flex flex-wrap align-middle items-center justify-between py-3 border-y ">
                      <b>Username</b>
                      <a>{getAgentResult.username}</a>
                    </li>
                    <li className="flex flex-wrap align-middle items-center justify-between py-3 border-y ">
                      <b>Email</b>
                      <a>{getAgentResult.email}</a>
                    </li>
                    <li className="flex flex-wrap align-middle items-center justify-between py-3 border-y ">
                      <b>Organization</b>
                      <div>
                        <a>
                          {getAgentResult.organization_name === null
                            ? "-"
                            : getAgentResult.organization_name}
                        </a>
                      </div>
                    </li>
                    <li className="flex flex-wrap align-middle items-center justify-between py-3 border-y ">
                      <b>Status</b>
                      <div className="flex">
                        {getAgentResult.is_active === true ? (
                          <span className="text-green-500">Active</span>
                        ) : (
                          <span className="text-red-500">Inactive</span>
                        )}
                      </div>
                    </li>
                    <li className="flex flex-wrap align-middle items-center justify-between py-3 border-y ">
                      <b>Banned</b>
                      <div className="flex">
                        {getAgentResult.ban === 1 ? (
                          <span className="text-yellow-500">Active</span>
                        ) : (
                          <span className="text-green-500">Inactive</span>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </CardContainer>
          </div>
          <div className="col-span-12 lg:col-span-9">
            <div className="mb-4">
              <CardContainer>
                {datauser &&
                  datauser.group_permissions.includes(
                    "can_change_role_group"
                  ) && (
                    <div className="flex flex-wrap justify-end mt-4 mr-2">
                      <button
                        onClick={handleChangeRole}
                        className="shadow-md hover:shadow-lg shadow-gray-500 rounded text-black py-1 px-5 mx-0.5 my-1 bg-gray-200 hover:bg-gray-300 "
                      >
                        Change role Group
                      </button>
                      <button
                        onClick={handleEdit}
                        className="shadow-md hover:shadow-lg shadow-gray-500 rounded text-black py-1 px-5 mx-0.5 my-1 bg-gray-200 hover:bg-gray-300 "
                      >
                        Edit
                      </button>
                      <button
                        onClick={handleChangepassword}
                        className="shadow-md hover:shadow-lg shadow-gray-500 rounded text-black py-1 px-5 mx-0.5 my-1 bg-gray-200 hover:bg-gray-300 "
                      >
                        Change Password
                      </button>
                      <button
                        onClick={handleDelete}
                        className="shadow-md hover:shadow-lg shadow-gray-500 rounded flex items-center text-white py-1 px-5 mx-0.5 my-1 bg-red-500 hover:bg-red-600 "
                      >
                        Delete
                      </button>
                    </div>
                  )}

                <div className="mx-4 mt-4">
                  <Tabs>
                    <TabList>
                      <Tab selectedClassName="bg-sky-800 text-white rounded-t ">
                        Open Tickets ({dataTicketOpen && dataTicketOpen.count})
                      </Tab>
                      <Tab selectedClassName="bg-sky-800 text-white  rounded-t ">
                        Closed Tickets (
                        {dataTicketClose && dataTicketClose.count})
                      </Tab>
                      <Tab selectedClassName="bg-sky-800 text-white rounded-t ">
                        Deleted Tickets (
                        {dataTicketDelete && dataTicketDelete.count})
                      </Tab>
                    </TabList>

                    <TabPanel>
                      <div className="p-4">
                        <div className="text-sm flex gap-2 items-center">
                          <button className="flex gap-1 p-2 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-emerald-500">
                            <input
                              id="checkbox-table"
                              type="checkbox"
                              className="form-checkbox"
                              checked={checkAllOpen}
                              onChange={handleCheckAllChangeOpen}
                            />
                          </button>

                          <button
                            onClick={HandleToDeleteForOpen}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-red-500"
                          >
                            Delete <FaTrash />
                          </button>

                          <button
                            onClick={HandleToCloseForOpen}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-yellow-500"
                          >
                            Close <FaWindowClose />
                          </button>

                          <button
                            onClick={handleRefreshOpen}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100"
                          >
                            <FaSync /> Refresh
                          </button>
                        </div>
                      </div>
                      {/* button perpage and input search  */}
                      <div className="flex flex-col md:flex-row md:justify-between align-middle px-4 mb-4 bg-neutral dark:bg-neutral-800 ">
                        <div className="p-1 inline-block align-middle">
                          <select
                            id="limitOpen"
                            value={limitOpen}
                            onChange={(e) =>
                              handleSelectLimitOpen(e.target.value)
                            }
                            className="border rounded-sm p-1 border-gray-300 dark:text-black focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                          </select>
                          <span className="mx-2 text-sm ">
                            Records per page
                          </span>
                        </div>
                        <div className="p-1 inline-block align-middle">
                          <span className="text-sm mr-2">Search:</span>
                          <input
                            id="searchOpen"
                            type="text"
                            value={searchOpen}
                            onChange={(e) => onSearchOpen(e.target.value)}
                            placeholder="Search ..."
                            className="p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                          />
                        </div>
                      </div>
                      {/* table and pagination */}
                      <div className="mx-4 ">
                        <div className="overflow-x-auto min-h-[55vh]">
                          <table className="w-full border-collapse border">
                            <thead className="text-left">
                              <tr className="">
                                {TABLE_HEAD.map((item, itemIdx) => (
                                  <th
                                    key={itemIdx}
                                    className="p-2 border text-sm whitespace-nowrap cursor-pointer"
                                    onClick={() => {
                                      item.field && handleSortOpen(item.field);
                                    }}
                                  >
                                    <span className="flex">
                                      {item.title}
                                      {item.field &&
                                        renderSortIconOpen(item.field)}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="text-left">
                              {/* loading  */}
                              {loadingOpen && (
                                <tr>
                                  <td
                                    className="text-center py-12"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-10 pb-6 flex justify-center items-center">
                                      <SyncLoader color="#4477CE" />
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Error */}
                              {errorOpen && (
                                <tr>
                                  <td
                                    className="text-center"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                                      {errorOpen}
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Result = 0 */}
                              {dataTicketOpen.results &&
                                dataTicketOpen.results.length === 0 && (
                                  <tr>
                                    <td
                                      className="text-center"
                                      colSpan={TABLE_HEAD.length + 1}
                                    >
                                      <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                                        No Data
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              {dataTicketOpen.results &&
                                dataTicketOpen.results.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-b bg-gray-50"
                                  >
                                    <td className="p-2 border">
                                      <input
                                        id={`checkbox-${item.id}`}
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={checkedItemsOpen.includes(
                                          item.id
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChangeOpen(e, item.id)
                                        }
                                      />
                                    </td>
                                    <td className="p-2 relative">
                                      <Link
                                        to={"/tickets/ticketdetail"}
                                        state={{ id: item.id }}
                                        className="text-blue-500 hover:text-blue-600 flex items-center"
                                      >
                                        {`${
                                          item.title &&
                                          slicingWord(item.title, 30)
                                        }`}
                                        <span
                                          title={`has ${item.ticket_thread_count_agent} ticket messages `}
                                          className="ml-1 text-green-600"
                                        >
                                          {`(${item.ticket_thread_count_agent})`}
                                        </span>
                                        <div>
                                          {item.source === 1 && (
                                            <FaGlobe
                                              title="Ticket Create From Web"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 2 && (
                                            <AiOutlineMail
                                              title="Ticket Create From Email"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 3 && (
                                            <FaUserEdit
                                              title="Ticket Create From Agent"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 4 && (
                                            <FaFacebook
                                              title="Ticket Create From Facebook"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 5 && (
                                            <FaTwitter
                                              title="Ticket Create From Twitter"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 6 && (
                                            <FaPhone
                                              title="Ticket Create From Telephone"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 7 && (
                                            <FaComment
                                              title="Ticket Create From Chat"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 8 && (
                                            <FaTelegram
                                              title="Ticket Create From Telegram"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_collaborator === 1 && (
                                            <IoPeople
                                              title="Ticket Collaborator"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_attachment && (
                                            <RiAttachment2
                                              title="Has File Attachment"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="p-2 border">
                                      <a href="">{item.ticket_number}</a>
                                    </td>
                                    <td className="p-2 border text-yellow-700 dark:text-yellow-200">
                                      {item.priority_name}
                                    </td>
                                    <td className="p-2 border text-green-700 dark:text-green-200">
                                      <p
                                        className="cursor-pointer"
                                        onClick={() =>
                                          HandlePreviewUser(item.user)
                                        }
                                      >
                                        {item.client_name}
                                      </p>
                                    </td>
                                    <td className="p-2 border">
                                      {item.assigned_to === null &&
                                      item.team === null ? (
                                        <span className="text-red-500">
                                          UNASSIGNED
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() =>
                                            HandlePreviewUser(item.assigned_to)
                                          }
                                          className="text-green-700 dark:text-green-200 cursor-pointer"
                                        >
                                          {item.team_name ??
                                            item.assignedto_name}
                                        </span>
                                      )}
                                    </td>
                                    <td className="p-2 border text-black dark:text-white">
                                      {moment(item.updated_at).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>

                          <div className="pt-5 py-11">
                            <CompPagination
                              handlePageClick={(e) => handlePageClickOpen(e)}
                              pageCount={
                                dataTicketOpen.count > 0
                                  ? dataTicketOpen.count
                                  : 0
                              }
                              limit={limitOpen}
                              offset={offsetOpen}
                              currentPage={currentPageOpen}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="p-4">
                        <div className="text-sm flex gap-2 items-center">
                          <button className="flex gap-1 p-2 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-emerald-500">
                            <input
                              id="checkbox-table"
                              type="checkbox"
                              className="form-checkbox"
                              checked={checkAllClose}
                              onChange={handleCheckAllChangeClose}
                            />
                          </button>

                          <button
                            onClick={HandleToDeleteForClose}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-red-500"
                          >
                            Delete <FaTrash />
                          </button>

                          <button
                            onClick={HandleToCloseForClose}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-yellow-500"
                          >
                            Close <FaWindowClose />
                          </button>

                          <button
                            onClick={handleRefreshClose}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100"
                          >
                            <FaSync /> Refresh
                          </button>
                        </div>
                      </div>
                      {/* button perpage and input search  */}
                      <div className="flex flex-col md:flex-row md:justify-between align-middle px-4 mb-4 bg-neutral dark:bg-neutral-800 ">
                        <div className="p-1 inline-block align-middle">
                          <select
                            id="limitClose"
                            value={limitClose}
                            onChange={(e) =>
                              handleSelectLimitClose(e.target.value)
                            }
                            className="border rounded-sm p-1 border-gray-300 dark:text-black focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                          </select>
                          <span className="mx-2 text-sm ">
                            Records per page
                          </span>
                        </div>
                        <div className="p-1 inline-block align-middle">
                          <span className="text-sm mr-2">Search:</span>
                          <input
                            id="searchClose"
                            type="text"
                            value={searchClose}
                            onChange={(e) => onSearchClose(e.target.value)}
                            placeholder="Search ..."
                            className="p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                          />
                        </div>
                      </div>
                      {/* table and pagination */}
                      <div className="mx-4 ">
                        <div className="overflow-x-auto min-h-[55vh]">
                          <table className="w-full border-collapse border">
                            <thead className="text-left">
                              <tr className="">
                                {TABLE_HEAD.map((item, itemIdx) => (
                                  <th
                                    key={itemIdx}
                                    className="p-2 border text-sm whitespace-nowrap cursor-pointer"
                                    onClick={() => {
                                      item.field && handleSortClose(item.field);
                                    }}
                                  >
                                    <span className="flex">
                                      {item.title}
                                      {item.field &&
                                        renderSortIconClose(item.field)}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="text-left">
                              {/* loading  */}
                              {loadingClose && (
                                <tr>
                                  <td
                                    className="text-center py-12"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-10 pb-6 flex justify-center items-center">
                                      <SyncLoader color="#4477CE" />
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Error */}
                              {errorClose && (
                                <tr>
                                  <td
                                    className="text-center"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                                      {errorClose}
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Result = 0 */}
                              {dataTicketClose.results &&
                                dataTicketClose.results.length === 0 && (
                                  <tr>
                                    <td
                                      className="text-center"
                                      colSpan={TABLE_HEAD.length + 1}
                                    >
                                      <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                                        No Data
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              {dataTicketClose.results &&
                                dataTicketClose.results.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-b bg-gray-50"
                                  >
                                    <td className="p-2 border">
                                      <input
                                        id={`checkbox-${item.id}`}
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={checkedItemsClose.includes(
                                          item.id
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChangeClose(e, item.id)
                                        }
                                      />
                                    </td>
                                    <td className="p-2 relative">
                                      <Link
                                        to={"/tickets/ticketdetail"}
                                        state={{ id: item.id }}
                                        className="text-blue-500 hover:text-blue-600 flex items-center"
                                      >
                                        {`${
                                          item.title &&
                                          slicingWord(item.title, 30)
                                        }`}
                                        <span
                                          title={`has ${item.ticket_thread_count_agent} ticket messages `}
                                          className="ml-1 text-green-600"
                                        >
                                          {`(${item.ticket_thread_count_agent})`}
                                        </span>
                                        <div>
                                          {item.source === 1 && (
                                            <FaGlobe
                                              title="Ticket Create From Web"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 2 && (
                                            <AiOutlineMail
                                              title="Ticket Create From Email"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 3 && (
                                            <FaUserEdit
                                              title="Ticket Create From Agent"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 4 && (
                                            <FaFacebook
                                              title="Ticket Create From Facebook"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 5 && (
                                            <FaTwitter
                                              title="Ticket Create From Twitter"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 6 && (
                                            <FaPhone
                                              title="Ticket Create From Telephone"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 7 && (
                                            <FaComment
                                              title="Ticket Create From Chat"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 8 && (
                                            <FaTelegram
                                              title="Ticket Create From Telegram"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_collaborator === 1 && (
                                            <IoPeople
                                              title="Ticket Collaborator"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_attachment && (
                                            <RiAttachment2
                                              title="Has File Attachment"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="p-2 border">
                                      <a href="">{item.ticket_number}</a>
                                    </td>
                                    <td className="p-2 border text-yellow-700 dark:text-yellow-200">
                                      {item.priority_name}
                                    </td>
                                    <td className="p-2 border text-green-700 dark:text-green-200">
                                      <p
                                        className="cursor-pointer"
                                        onClick={() =>
                                          HandlePreviewUser(item.user)
                                        }
                                      >
                                        {item.client_name}
                                      </p>
                                    </td>
                                    <td className="p-2 border">
                                      {item.assigned_to === null &&
                                      item.team === null ? (
                                        <span className="text-red-500">
                                          UNASSIGNED
                                        </span>
                                      ) : (
                                        <span
                                          className="text-green-700 dark:text-green-200 cursor-pointer"
                                          onClick={() =>
                                            HandlePreviewUser(item.assigned_to)
                                          }
                                        >
                                          {item.team_name ??
                                            item.assignedto_name}
                                        </span>
                                      )}
                                    </td>
                                    <td className="p-2 border text-black dark:text-white">
                                      {moment(item.updated_at).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>

                          <div className="pt-5 py-11">
                            <CompPagination
                              handlePageClick={(e) => handlePageClickClose(e)}
                              pageCount={
                                dataTicketClose.count > 0
                                  ? dataTicketClose.count
                                  : 0
                              }
                              limit={limitClose}
                              offset={offsetClose}
                              currentPage={currentPageClose}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="p-4">
                        <div className="text-sm flex gap-2 items-center">
                          <button className="flex gap-1 p-2 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-emerald-500">
                            <input
                              id="checkbox-table"
                              type="checkbox"
                              className="form-checkbox"
                              checked={checkAllDelete}
                              onChange={handleCheckAllChangeDelete}
                            />
                          </button>

                          <button
                            onClick={HandleToDeleteForDelete}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-red-500"
                          >
                            Delete <FaTrash />
                          </button>

                          <button
                            onClick={HandleToCloseForDelete}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 text-yellow-500"
                          >
                            Close <FaWindowClose />
                          </button>

                          <button
                            onClick={handleRefreshDelete}
                            className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100"
                          >
                            <FaSync /> Refresh
                          </button>
                        </div>
                      </div>
                      {/* button perpage and input search  */}
                      <div className="flex flex-col md:flex-row md:justify-between align-middle px-4 mb-4 bg-neutral dark:bg-neutral-800 ">
                        <div className="p-1 inline-block align-middle">
                          <select
                            id="limitDelete"
                            value={limitDelete}
                            onChange={(e) =>
                              handleSelectLimitDelete(e.target.value)
                            }
                            className="border rounded-sm p-1 border-gray-300 dark:text-black focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                          </select>
                          <span className="mx-2 text-sm ">
                            Records per page
                          </span>
                        </div>
                        <div className="p-1 inline-block align-middle">
                          <span className="text-sm mr-2">Search:</span>
                          <input
                            id="searchDelete"
                            type="text"
                            value={searchDelete}
                            onChange={(e) => onSearchDelete(e.target.value)}
                            placeholder="Search ..."
                            className="p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                          />
                        </div>
                      </div>
                      {/* table and pagination */}
                      <div className="mx-4 ">
                        <div className="overflow-x-auto min-h-[55vh]">
                          <table className="w-full border-collapse border">
                            <thead className="text-left">
                              <tr className="">
                                {TABLE_HEAD.map((item, itemIdx) => (
                                  <th
                                    key={itemIdx}
                                    className="p-2 border text-sm whitespace-nowrap cursor-pointer"
                                    onClick={() => {
                                      item.field &&
                                        handleSortDelete(item.field);
                                    }}
                                  >
                                    <span className="flex">
                                      {item.title}
                                      {item.field &&
                                        renderSortIconDelete(item.field)}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="text-left">
                              {/* loading  */}
                              {loadingDelete && (
                                <tr>
                                  <td
                                    className="text-center py-12"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-10 pb-6 flex justify-center items-center">
                                      <SyncLoader color="#4477CE" />
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Error */}
                              {errorDelete && (
                                <tr>
                                  <td
                                    className="text-center"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                                      {errorDelete}
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {/* Result = 0 */}
                              {dataTicketDelete.results &&
                                dataTicketDelete.results.length === 0 && (
                                  <tr>
                                    <td
                                      className="text-center"
                                      colSpan={TABLE_HEAD.length + 1}
                                    >
                                      <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                                        No Data
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              {dataTicketDelete.results &&
                                dataTicketDelete.results.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-b bg-gray-50"
                                  >
                                    <td className="p-2 border">
                                      <input
                                        id={`checkbox-${item.id}`}
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={checkedItemsDelete.includes(
                                          item.id
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChangeDelete(e, item.id)
                                        }
                                      />
                                    </td>
                                    <td className="p-2 relative">
                                      <Link
                                        to={"/tickets/ticketdetail"}
                                        state={{ id: item.id }}
                                        className="text-blue-500 hover:text-blue-600 flex items-center"
                                      >
                                        {`${
                                          item.title &&
                                          slicingWord(item.title, 30)
                                        }`}
                                        <span
                                          title={`has ${item.ticket_thread_count_agent} ticket messages `}
                                          className="ml-1 text-green-600"
                                        >
                                          {`(${item.ticket_thread_count_agent})`}
                                        </span>
                                        <div>
                                          {item.source === 1 && (
                                            <FaGlobe
                                              title="Ticket Create From Web"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 2 && (
                                            <AiOutlineMail
                                              title="Ticket Create From Email"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 3 && (
                                            <FaUserEdit
                                              title="Ticket Create From Agent"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 4 && (
                                            <FaFacebook
                                              title="Ticket Create From Facebook"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 5 && (
                                            <FaTwitter
                                              title="Ticket Create From Twitter"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 6 && (
                                            <FaPhone
                                              title="Ticket Create From Telephone"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 7 && (
                                            <FaComment
                                              title="Ticket Create From Chat"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                          {item.source === 8 && (
                                            <FaTelegram
                                              title="Ticket Create From Telegram"
                                              className="text-green-600 dark:text-primary-400 text-xl md:text-xl lg:text-lg "
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_collaborator === 1 && (
                                            <IoPeople
                                              title="Ticket Collaborator"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                        <div>
                                          {item.ticket_attachment && (
                                            <RiAttachment2
                                              title="Has File Attachment"
                                              className="text-black dark:text-white text-xl md:text-xl lg:text-lg"
                                            />
                                          )}
                                        </div>
                                      </Link>
                                    </td>
                                    <td className="p-2 border">
                                      <a href="">{item.ticket_number}</a>
                                    </td>
                                    <td className="p-2 border text-yellow-700 dark:text-yellow-200">
                                      {item.priority_name}
                                    </td>
                                    <td className="p-2 border text-green-700 dark:text-green-200">
                                      <p
                                        className="cursor-pointer"
                                        onClick={() =>
                                          HandlePreviewUser(item.user)
                                        }
                                      >
                                        {item.client_name}
                                      </p>
                                    </td>
                                    <td className="p-2 border">
                                      {item.assigned_to === null &&
                                      item.team === null ? (
                                        <span className="text-red-500">
                                          UNASSIGNED
                                        </span>
                                      ) : (
                                        <span
                                          className="text-green-700 dark:text-green-200 cursor-pointer"
                                          onClick={() =>
                                            HandlePreviewUser(item.assigned_to)
                                          }
                                        >
                                          {item.team_name ??
                                            item.assignedto_name}
                                        </span>
                                      )}
                                    </td>
                                    <td className="p-2 border text-black dark:text-white">
                                      {moment(item.updated_at).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>

                          <div className="pt-5 py-11">
                            <CompPagination
                              handlePageClick={(e) => handlePageClickDelete(e)}
                              pageCount={
                                dataTicketDelete.count > 0
                                  ? dataTicketDelete.count
                                  : 0
                              }
                              limit={limitDelete}
                              offset={offsetDelete}
                              currentPage={currentPageDelete}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </CardContainer>
            </div>

            <CardContainer title={"User Report"}>
              <div className="m-4">
                <div className="grid grid-cols-12 gap-4 mb-4">
                  <div className="col-span-3">
                    <label className="font-bold">Start date :</label>
                    <input
                      id="startdate"
                      type="date"
                      value={startdate}
                      onChange={handleChangeStartdate}
                      className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                  </div>
                  <div className="col-span-3">
                    <label className="font-bold">End date :</label>
                    <input
                      id="enddate"
                      type="date"
                      value={enddate}
                      onChange={handleChangeEnddate}
                      className="p-1 w-full col-span-12 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                  </div>
                  <div className="col-span-3">
                    <button
                      onClick={submitFilter}
                      className="mt-6 rounded text-white py-1.5 ml-1 px-5 mx-0.5 my-1 bg-sky-600 hover:bg-sky-700 "
                    >
                      Send
                    </button>
                  </div>
                </div>

                {/* loading */}
                {getReportLoading && (
                  <div>
                    <div className="pt-10 pb-6 flex justify-center items-center">
                      <SyncLoader color="#4477CE" />
                    </div>
                  </div>
                )}

                {getReportResult.data && (
                  <>
                    {/* Legend  */}
                    <div className="flex gap-x-6 flex-wrap text-sm mb-4">
                      <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-sm shadow bg-[#7dd3fc]"></div>
                        <div>
                          {getReportResult.data &&
                            getReportResult.data?.ticket_created}{" "}
                          Tickets Created
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-sm shadow bg-[#34d399]"></div>
                        <div>
                          {getReportResult.data &&
                            getReportResult.data?.ticket_reopened}{" "}
                          Tickets Reopened
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-sm shadow bg-[#f87171]"></div>
                        <div>
                          {getReportResult.data &&
                            getReportResult.data?.ticket_closed}{" "}
                          Tickets Closed
                        </div>
                      </div>
                    </div>
                    {/* Grafik  */}
                    <div>
                      <ResponsiveContainer width="100%" height={400}>
                        <AreaChart data={getReportResult.data?.report}>
                          <CartesianGrid strokeDasharray="1 0" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <Tooltip
                            contentStyle={{
                              backgroundColor:
                                colorMode === "dark" ? "#111827" : "white",
                              border: 0,
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="created"
                            stroke="#7dd3fc"
                            fill="url(#createdID)"
                          />
                          <Area
                            type="monotone"
                            dataKey="reopened"
                            stroke="#34d399"
                            fill="url(#reopenedID)"
                          />
                          <Area
                            type="monotone"
                            dataKey="closed"
                            stroke="#f87171"
                            fill="url(#closedID)"
                          />
                          <defs>
                            <linearGradient
                              id="createdID"
                              x1="0"
                              y1="0"
                              x2="0"
                              y2="1"
                            >
                              <stop
                                offset="5%"
                                stopColor="#7dd3fc"
                                stopOpacity={0.6}
                              />
                              <stop
                                offset="95%"
                                stopColor="#7dd3fc"
                                stopOpacity={0}
                              />
                            </linearGradient>
                            <linearGradient
                              id="reopenedID"
                              x1="0"
                              y1="0"
                              x2="0"
                              y2="1"
                            >
                              <stop
                                offset="5%"
                                stopColor="#34d399"
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="95%"
                                stopColor="#34d399"
                                stopOpacity={0}
                              />
                            </linearGradient>
                            <linearGradient
                              id="closedID"
                              x1="0"
                              y1="0"
                              x2="0"
                              y2="1"
                            >
                              <stop
                                offset="5%"
                                stopColor="#f87171"
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="95%"
                                stopColor="#f87171"
                                stopOpacity={0}
                              />
                            </linearGradient>
                          </defs>
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </>
                )}
              </div>
            </CardContainer>
          </div>
        </div>
        {/* Modal */}
        <ModalChangePassword
          isOpen={modalPassword}
          onClose={closeModalPassword}
          item={getAgentResult && getAgentResult}
        />
        {/* Modal */}
        {getAgentResult && (
          <ModalChangeRole
            isOpen={modalChangeRole}
            onClose={closeModalChangeRole}
            item={getAgentResult}
            callback={() => {
              fetchDataUser();
              fetchDataUser();
            }}
          />
        )}
      </Container>
    </>
  );
};

export default ViewUserAgent;
